<div class="select_trigger_cont">
	<button class="SelectTrigger_button {{sortShow?'active_sort_menu':''}}"
			(click)="sortShow = !sortShow">
			<span class="material-symbols-outlined deskshow" *ngIf="!sortShow">
				sort
			</span>
		<span class="material-symbols-outlined" *ngIf="sortShow">
				close
			</span>
		<span class="sort_text">sort by</span>
	</button>

	<div class="select" [@enterAnimation] *ngIf="sortShow">
		<div class="option {{selectedSortOption==='availability'?'active_sort_option':''}}" (click)="sort('availability')">
			By Availability
		</div>
		<div class="option {{selectedSortOption==='new-arrival'?'active_sort_option':''}}" (click)="sort('new-arrival')">
			New Arrival
		</div>
		<div class="option {{selectedSortOption==='low-to-high'?'active_sort_option':''}}" (click)="sort('low-to-high')">
			Price Low To High
		</div>
		<div class="option {{selectedSortOption==='high-to-low'?'active_sort_option':''}}" (click)="sort('high-to-low')">
			Price High To Low
		</div>
	</div>
</div>
